import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Date',
  name: 'publicationDate',
  type: 'singleSelect',
  selected: { value: '', display: 'All' },
  options: [
    { value: '', display: 'All' },
    { value: 'LE6M', display: '6 months' },
    { value: 'LE1Y', display: '1 year' },
    { value: 'LE2Y', display: '2 years' },
    { value: 'LE5Y', display: '5 years' },
  ],
};

const storeName = 'publicationDate';
export const usePublicationDateFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updatePublicationDateFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'publicationDate' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updatePublicationDateFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'publication_date', action: 'select', item_id: value }, '7e823698-b0c5-4240-8a07-a8105f89ce27');
  }
  usePublicationDateFilter.setState({ selected: option }, false, {
    type: 'updatePublicationDateFilterOption',
  });
  setFilterValue(usePublicationDateFilter, option);
};

export const clearPublicationDateFilterOption = (option) => {
  usePublicationDateFilter.setState({ ...initialState }, false, {
    type: 'clearPublicationDateFilterOption',
  });
};
